import { css } from 'linaria';
import { theme } from '../../Theme';

export const headerIconStyle = css`
  height: 20px;
  cursor: pointer;
  color: ${theme.colors.black};
`;
